"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var normalizr_1 = require("normalizr");
var lodash_1 = require("lodash");
var immutable_1 = require("immutable");
var schema_1 = require("./schema");
var normalize_1 = __importDefault(require("./normalize"));
function renormalize(entityName, input, entities) {
    var _a, _b;
    var entitySchema = schema_1.selectSchema(entityName, Array.isArray(input));
    if (!entitySchema)
        return null;
    var denormalized = normalizr_1.denormalize((_a = {}, _a[entityName] = input, _a), (_b = {},
        _b[entityName] = entitySchema,
        _b), entities);
    var bypassSchema = bypassSchemaIdProcessor(entitySchema);
    var renormalized = normalize_1.default(denormalized, bypassSchema);
    return renormalized;
}
exports.default = renormalize;
var DEFAULT_ID_ATTRIBUTE = 'id';
var getDefaultGetId = function (input) {
    return immutable_1.isImmutable(input)
        ? input.get(DEFAULT_ID_ATTRIBUTE)
        : input[DEFAULT_ID_ATTRIBUTE];
};
var transformSchemaKeyedInput = function (input) {
    return lodash_1.transform(input, function (acc, maybeSchema, key) {
        acc[key] = bypassSchemaIdProcessor(maybeSchema);
        return acc;
    });
};
var bypassSchemaIdProcessor = function (inputSchema) {
    return lodash_1.transform(inputSchema, function (acc, val, key) {
        // Recursively process schema object
        // NOTE: "normalizr" version MUST be the same across the app
        if (val instanceof normalizr_1.schema.Array || val instanceof normalizr_1.schema.Entity) {
            acc[key] = bypassSchemaIdProcessor(val);
            return acc;
        }
        // Copy inner schema fields, override "id" processors to default
        if (key !== 'schema') {
            acc[key] = val;
            if (key === '_processStrategy') {
                acc[key] = function (v) { return (__assign({}, v)); };
            }
            if (key === '_idAttribute') {
                acc[key] = DEFAULT_ID_ATTRIBUTE;
            }
            if (key === '_getId') {
                acc[key] = getDefaultGetId;
            }
            return acc;
        }
        // Process inner schema on object keys
        acc[key] = transformSchemaKeyedInput(val);
        return acc;
    });
};
//# sourceMappingURL=renormalize.js.map